import { useState } from 'react';

import Modal from './modal';

import './styles.css';
import Logo from './images/logo.jpg';

export const Step1 = ({onNext, onSelectBusinessType, selectedBusinessType}) => {
  const [selected, setSelected] = useState(selectedBusinessType);

  const handleSelect = (type) => {
    setSelected(type);
    onSelectBusinessType({ type });

    setTimeout(() => {
      onNext();
    }, 400);
  };

  return (
    <Modal className="step-1">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h1>Welcome to Market Games</h1>
      <h2>Which do you cover?</h2>
      <p className="onboarding-choose-label">Choose one</p>
      <div className="onboarding-welcome-buttons">
        <button
          className={`onboarding-welcome-button ${selected === 'corporate' ? 'selected' : ''}`}
          onClick={() => handleSelect('corporate')}
        >
          Incorporated Companies
          <span>(e.g. Common Stocks)</span>
        </button>
        <button
          className={`onboarding-welcome-button ${selected === 'noncorporate' ? 'selected' : ''}`}
          onClick={() => handleSelect('noncorporate')}
        >
          Non-incorporated Companies
          <span>(e.g. Owner's Capital)</span>
        </button>
      </div>
    </Modal>
  )
};
